const KIND_TITLES = {
    order: "Order",
    status: "Status change",
    note: "Note",
    response: "Payer response",
    document: "Document",
    answer: "Question",
    answers: "Questions",
    tags: "Tags",
    assignees: "Assigned",
};
const SHORT_DATE = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });
function groupKey(citation) {
    return citation.kind === "order" ? "order" : citation.id;
}
function titleOf(citation) {
    if (["note", "document", "order"].includes(citation.kind))
        return citation.label;
    return KIND_TITLES[citation.kind] ?? "Source";
}
function whenOf(citation) {
    if (!citation.at)
        return "";
    const date = new Date(citation.at);
    return Number.isNaN(date.getTime()) ? "" : SHORT_DATE.format(date);
}
function targetOf(citation) {
    if (!citation.ref)
        return null;
    if (citation.kind === "answer")
        return "question";
    if (citation.kind === "document" || citation.kind === "response")
        return "document";
    return null;
}
/** Each section's sentences with their sources, numbered once across the whole recap in reading order. */
export function recapLines(sections, citations) {
    const byId = Object.fromEntries(citations.map((citation) => [citation.id, citation]));
    const numbers = new Map();
    for (const section of sections) {
        for (const sentence of section.sentences) {
            for (const id of sentence.sourceIds) {
                const citation = byId[id];
                if (citation && !numbers.has(groupKey(citation)))
                    numbers.set(groupKey(citation), numbers.size + 1);
            }
        }
    }
    const sourcesFor = (sourceIds) => {
        const grouped = new Map();
        for (const id of sourceIds) {
            const citation = byId[id];
            if (citation)
                grouped.set(groupKey(citation), [...(grouped.get(groupKey(citation)) ?? []), citation]);
        }
        return [...grouped.entries()]
            .map(([key, group]) => ({
            key,
            number: numbers.get(key) ?? 0,
            title: group.length > 1 ? KIND_TITLES.order : titleOf(group[0]),
            when: group.length > 1 ? "" : whenOf(group[0]),
            body: group.map((citation) => citation.preview || citation.text).join("\n"),
            target: group.length === 1 ? targetOf(group[0]) : null,
            ref: group[0].ref,
        }))
            .sort((a, b) => a.number - b.number);
    };
    return Object.fromEntries(sections.map((section) => [
        section.key,
        section.sentences.map((sentence) => ({ text: sentence.text, sources: sourcesFor(sentence.sourceIds) })),
    ]));
}
